
// Related articles for the armpit pain and lymph nodes article
export const armpitPainLymphNodesRelatedArticles = [
  {
    id: "armpit-pain-causes",
    slug: "understanding-armpit-pain",
    title: "Understanding Armpit Pain: 10 Common Causes and Effective Remedies"
  },
  {
    id: "armpit-health-basics",
    slug: "armpit-health-basics",
    title: "Armpit Health: The Basics Everyone Should Know"
  },
  {
    id: "breast-health",
    slug: "breast-health-self-examination",
    title: "Breast Health: The Importance of Regular Self-Examinations"
  }
];
